module.exports = __webpack_public_path__ + "static/media/jahan_Copy.8ed45084.jpg";